export const FetcherKeys = {
  ACTIVE_COUPONS: "active-coupons-fetcher",
  ACTIVE_SUBSCRIPTION: "active-subscription-fetcher",
  ALL_ISSUES: "all-issues-fetcher",
  API_KEYS: "api-keys-fetcher",
  BILLING_ADDRESS: "billing-address-fetcher",
  BILLING_DETAILS: "billing-details-fetcher",
  CHARTS_DATA: "charts-data-fetcher",
  COUNTERS: "counters-fetcher",
  COUPON: "coupon-fetcher",
  INVOICES: "invoices-fetcher",
  INVOICES_PAGINATED: "invoices-paginated-fetcher",
  PAYMENT_SOURCES: "payment-sources-fetcher",
  PLANS: "plans-fetcher",
  PRICING_OPTIONS: "pricing-options-fetcher",
  STATUSPAGE_ISSUES: "statuspage-issues-fetcher",
  UPGRADE_SUBSCRIPTION: "upgrade-subscription-fetcher",
}

export const Fetchers = {
  ACTIVE_COUPONS_FETCHER: { key: FetcherKeys.ACTIVE_COUPONS },
  ACTIVE_SUBSCRIPTION_FETCHER: { key: FetcherKeys.ACTIVE_SUBSCRIPTION },
  ALL_ISSUES_FETCHER: { key: FetcherKeys.ALL_ISSUES },
  API_KEYS_FETCHER: { key: FetcherKeys.API_KEYS },
  BILLING_ADDRESS_FETCHER: { key: FetcherKeys.BILLING_ADDRESS },
  BILLING_DETAILS_FETCHER: { key: FetcherKeys.BILLING_DETAILS },
  CHARTS_DATA: { key: FetcherKeys.CHARTS_DATA },
  COUNTERS_FETCHER: { key: FetcherKeys.COUNTERS },
  COUPON_FETCHER: { key: FetcherKeys.COUPON },
  INVOICES_FETCHER: { key: FetcherKeys.INVOICES },
  INVOICES_PAGINATED_FETCHER: { key: FetcherKeys.INVOICES_PAGINATED },
  PAYMENT_SOURCES_FETCHER: { key: FetcherKeys.PAYMENT_SOURCES },
  PLANS_FETCHER: { key: FetcherKeys.PLANS },
  PRICING_OPTIONS_FETCHER: { key: FetcherKeys.PRICING_OPTIONS },
  STATUSPAGE_ISSUES_FETCHER: { key: FetcherKeys.STATUSPAGE_ISSUES },
  UPGRADE_SUBSCRIPTION_FETCHER: { key: FetcherKeys.UPGRADE_SUBSCRIPTION },
};
